<template>
  <div v-if="false">
    <!-- IF REPORT IS GENERATING -->
    <div v-if="store_details_processing" class="download-loading-prompt-sec fixed py-1 pr-6 pl-2 text-white rounded"
      style="left: 85px; z-index: 999;" :style="[store_processing_completed ? { bottom: '85px' } : { bottom: '15px' }]">
      <span class="flex items-center">
        <svg id="L9" style="width:50px" version="1.1" xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 0 0"
          xml:space="preserve">
          <path fill="#fff"
            d="M73,50c0-12.7-10.3-23-23-23S27,37.3,27,50 M30.9,50c0-10.5,8.5-19.1,19.1-19.1S69.1,39.5,69.1,50">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50"
              to="360 50 50" repeatCount="indefinite" />
          </path>
        </svg>
        <p>Labour hours projections are getting updated from tomorrow till next week Sunday.</p>
      </span>
    </div>
    <!-- IF REPORT IS READY -->
    <!-- <div v-if="store_processing_completed" class="download-loading-prompt-sec fixed py-3 pr-6 pl-2 text-white rounded"
      style="bottom: 15px; left: 85px; z-index: 999;">
      <span class="flex items-center">
        <img class="mx-4 my-2" src="../../assets/icons/file-downloaded.svg" alt="Done" width="20px" srcset="">
        <p>Labour hours updated successfully!</p>
        <i class="el-icon-close pl-2 cursor-pointer" @click="closeProcessRunningPrompt"></i>
      </span>
    </div> -->
    <!-- Updated preview -->
    <el-dialog title="Under process" :visible.sync="store_processing_completed" width="35%"
      custom-class="auto-scheduling-dialog">
      <div class="p-2 mt-4 text-center">
        <img src="../../assets/illustration/wait.svg" style="width: 200px" alt="" />
        <div style="font-size: 14px; line-height: 19px" class="mt-3">
          System is updating the ideal labours. Please check the updated forecast after some time. We will inform you with an email.
        </div>
      </div>
      <div slot="footer" class="dialog-footer mt-2">
        <a class="font-semibold cursor-pointer mr-6" @click="store_processing_completed = false">Okay</a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { CommonMixin } from "../../../mixins/common.mixin";
export default {
  name: 'ProcessRunningNotifier',
  mixins: [CommonMixin],
}
</script>

<style lang="scss" scoped>
.download-loading-prompt-sec {
  background-color: #2e323a;
}
</style>